import { useLocalization } from '@/hooks/use-localization';
import clsx from 'clsx';
import { useBrandedColors } from '../hooks/use-branded-colors';

type Props = {
    monthlyAmount: number | null;
    monthlyAmountTitle: string;
    brandColor: string;
};

export const Results = ({ monthlyAmount, monthlyAmountTitle, brandColor }: Props) => {
    const { formatCurrency } = useLocalization();
    const formattedAmount = monthlyAmount ? formatCurrency(monthlyAmount) : '';
    const { useBrandedColorsBool } = useBrandedColors({ brandColor });

    return (
        <>
            <div className="r-flex r-w-full r-items-center r-justify-between xl:r-hidden">
                <p className={clsx(useBrandedColorsBool ? 'r-text-black' : 'r-text-primary-500')}>{monthlyAmountTitle}</p>
                <p className={clsx('r-text-2xl', useBrandedColorsBool ? 'r-text-black' : 'r-text-primary-500')}>{formattedAmount}</p>
            </div>
            <div
                style={useBrandedColorsBool ? { background: brandColor } : {}}
                className="-r-mt-32 r-hidden r-h-44 r-w-44 r-space-y-1 r-rounded-full r-bg-primary-400 r-font-[500] r-text-white xl:r-flex xl:r-flex-col xl:r-items-center xl:r-justify-center"
            >
                <p>{monthlyAmountTitle}</p>
                <p className="r-text-2xl">{formattedAmount}</p>
            </div>
        </>
    );
};
